import React from 'react';
import { useTranslation } from 'react-i18next';

export interface FolderTravelerTagProps {
  isChild: boolean;
}

/** KD-3842: Adult / Child tag, at the trip departure date. */
export default function FolderTravelerTag({ isChild }: FolderTravelerTagProps) {
  const { t } = useTranslation('folders');

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${
        isChild
          ? 'bg-blue-600/10 text-blue-700'
          : 'bg-gray-500/10 text-gray-600'
      }`}
    >
      {isChild ? t('travelers.child') : t('travelers.adult')}
    </span>
  );
}
